export interface 棚番設定表示条件型 {
  部署コード: string | null;
  棚名: string | null;
  棚番: string | null;
  メーカー名: string | null;
  商品名カナ: string | null;
  商品区分: string | null;
}

export interface 全指定棚番設定型 {
  棚名: string | null;
  棚番: string | null;
}

export interface 棚番設定取得結果一覧型 {
  棚番設定リスト: 棚番設定取得結果型[];
}

export interface 棚番設定一覧取得結果返却型 {
  棚番設定リスト: 棚番設定取得結果型[];
  アラートメッセージ: string;
}

export interface 棚番設定取得結果型 {
  商品コード: string;
  棚番リビジョン番号: number | null;
  メーカー名: string;
  商品名: string;
  商品区分: string;
  規格容量: string;
  棚名: string | null;
  棚番: string | null;
  部署コード: string;
  部署名: string;
}

export interface 棚番設定型 {
  key: string;
  商品コード: string;
  商品区分: string;
  棚番リビジョン番号: number | null;
  メーカー名: string;
  商品名: string;
  規格容量: string;
  棚名: string | null;
  棚番: string | null;
  部署コード: string;
  部署名: string;
}

export interface 棚番設定更新型 {
  棚番設定更新リスト: 棚番設定更新レコード型[];
}

export interface 棚番設定更新レコード型 {
  部署コード: string;
  商品コード: string;
  棚番リビジョン番号: number | null;
  棚名: string | null;
  棚番: string | null;
}

export interface 棚番設定出力依頼型 {
  棚番設定出力レコードリスト: 棚番設定出力レコード型[];
}

export interface 棚番設定出力レコード型 {
  商品コード: string;
  部署コード: string;
}

export interface 棚番設定取込不可一覧型 {
  棚番設定取込不可リスト: 棚番設定取込不可型[];
}

export interface 棚番設定取込不可型 {
  商品コード: string | null;
  JANコード: string | null;
  メーカー名: string | null;
  商品名: string | null;
  規格容量: string | null;
  棚名: string | null;
  棚番: string | null;
  部署名: string | null;
  棚番設定取込不可区分: string;
}

export enum 商品区分型 {
  指定なし = '指定なし',
  医薬品 = '医薬品',
  その他品 = 'その他品',
  備蓄品 = '備蓄品',
}

